import PropTypes from "prop-types";
import React from "react";

import ViewBlockIcon from "../../utils/Icons/ViewBlock";

const ViewDeactivateButton = ({
  containerClassName,
  className,
  onClick,
  label
}) => {
  return (
    <div
      className={`${containerClassName} h-100 border-radius-8 error-border-small bg-white pointer padding-10 error-hover ${label ? "d-flex gap-2 align-items-center " : ""}`}
      onClick={onClick}>
      <ViewBlockIcon
        className={`table-icon action-icon  ${className}`}
      />

      <span className="text-error fweight-500 fsize-16 d-none d-md-block">
        {label}
      </span>
    </div>
  );
};

ViewDeactivateButton.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string
};

export default ViewDeactivateButton;
